import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, effect, inject, input, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { TooltipModule } from 'primeng/tooltip';

import { AttachmentItemComponent } from './attachment-item/attachment-item.component';
import { AttachmentsUploadHandler } from './attatchments-upload.handler';
import { ButtonDirective } from '../directives/button.directive';
import { CallPipe } from '../pipes/call.pipe';
import { AttachmentsService } from '../services/attachments.service';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-attachments-manager',
  standalone: true,
  imports: [
    AsyncPipe,
    AttachmentItemComponent,
    BadgeModule,
    ButtonDirective,
    CallPipe,
    FileUploadModule,
    ProgressBarModule,
    TooltipModule,
    TranslateModule,
  ],
  templateUrl: './attachments-manager.component.html',
  styleUrl: './attachments-manager.component.scss',
})
export class AttachmentsManagerComponent {
  readonly attachmentsService = inject(AttachmentsService);
  readonly toast = inject(ToastService);
  readonly cdr = inject(ChangeDetectorRef);

  @ViewChild(FileUpload, { static: false }) private fileUpload?: FileUpload;

  readonly attachmensUploadHandler = input.required<AttachmentsUploadHandler>();
  readonly showCount = input<boolean>(true);
  readonly customTitle = input(false);

  readonly resolveUploadedStorageObject = (file: File) => {
    return this.attachmensUploadHandler().getUploadedStorageObject(file);
  };

  constructor(private config: PrimeNGConfig) {
    effect(() => {
      this.attachmensUploadHandler().setFileUpload(this.fileUpload);
    });
  }

  formatSize(bytes: number) {
    const k = 1024;
    const dm = 3;
    const sizes = this.config.translation.fileSizeTypes ?? [];
    if (bytes === 0) {
      return `0 ${sizes[0]}`;
    }

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${formattedSize} ${sizes[i]}`;
  }

  async upload() {
    await this.attachmensUploadHandler().startUpload();
  }

  isImage(type: string) {
    return this.attachmensUploadHandler().isImage(type);
  }
}
